import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import { horseListService } from "../../api/horseList.service";
import Modal from "../elements/Modal";

function ListsModal({ isOpenLists, setIsOpenLists, onSelect }) {
	const navigate = useNavigate();
	const [horseLists, setHorseLists] = useState([]);
	const [selectedList, setSelectedList] = useState(null);
	const [loading, setLoading] = useState(true);
	const [loadError, setLoadError] = useState(false);

	useEffect(() => {
		let cancelled = false;
		horseListService
			.list()
			.then((response) => {
				if (!cancelled) setHorseLists(response.results || []);
			})
			.catch(() => {
				if (!cancelled) setLoadError(true);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	const options = [
		...horseLists.map((list) => ({
			value: list.id,
			label: list.name,
			type: list.type,
		})),
		{ value: "new", label: "+ Create a new list", type: "new" },
	];

	function handleChange(option) {
		if (option?.value === "new") {
			setIsOpenLists(false);
			navigate("/new-list");
			return;
		}
		setSelectedList(option);
	}

	function closeModal() {
		setSelectedList(null);
		setIsOpenLists(false);
	}

	return (
		<Modal isOpen={isOpenLists} className="multi-list-modal-container">
			<div className="multi-list-modal">
				<div className="multi-list-modal__header">
					<div><span>Import horses</span><h2>Use a saved list</h2></div>
					<button type="button" onClick={closeModal} aria-label="Close saved lists"><i className="fa fa-times" aria-hidden="true" /></button>
				</div>
				<div className="multi-list-modal__content">
					<p>Choose a sire or dam list. Its horses will be added to the matching side and duplicates will be skipped.</p>
					{loading ? <div className="multi-list-modal__state">Loading your lists…</div> : loadError ? <div className="multi-list-modal__state is-error">Lists could not be loaded.</div> : (
						<>
							<label htmlFor="multi-saved-list">Saved list</label>
							<Select
								inputId="multi-saved-list"
								options={options}
								value={selectedList}
								onChange={handleChange}
								placeholder="Choose a sire or dam list"
								isClearable
								className="react-select-container"
								classNamePrefix="react-select"
								menuPortalTarget={document.body}
								styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
							/>
						</>
					)}
				</div>
				<div className="multi-list-modal__actions">
					<button type="button" className="is-secondary" onClick={closeModal}>Cancel</button>
					<button type="button" onClick={() => { onSelect(selectedList); setSelectedList(null); }} disabled={!selectedList}>Add list</button>
				</div>
			</div>
		</Modal>
	);
}

export default ListsModal;
